import {FilterRangeInputs} from 'plugins/modules/filter/components/FilterRangeInputs';
import {BrowserFilters} from 'plugins/modules/filter/helpers/BrowserFilters';
import {IFilterFacet, TFilterRangeValue} from 'plugins/modules/filter/types';
import React, {FC, useCallback, useContext, useMemo} from 'react';
import {isBrowserContext} from 'core/helpers';
import {useFiltersGtag} from 'hooks/analytics/gtag/catalog/useFiltersGtag';
import {FilterContext} from 'plugins/modules/filter/context/new';
import {getFilterTitleForGtag, isFilterWithCount} from 'plugins/modules/filter/helpers';
import {useFiltersRouterPush} from '../../hooks/useFiltersRouterPush';
import {EventAction} from 'modules/google-analytics/constants';

interface IProps {
    filter: IFilterFacet;
}

export const RangeFilterController: FC<IProps> = ({filter}) => {
    const {pushRoute} = useFiltersRouterPush();
    const {filterList} = useContext(FilterContext);

    const sendFiltersGtag = useFiltersGtag();

    const filterInstance = useMemo(() => {
        if (!isBrowserContext()) {
            return null;
        }

        return BrowserFilters.getInstance();
    }, []);

    const handleApply = useCallback(
        (values: TFilterRangeValue) => {
            if (!filterInstance) {
                return;
            }

            const data = {
                code: filter.code,
                values,
            };

            const [min, max] = values;

            const filterTitleForGtag = getFilterTitleForGtag(filterList, {
                ...filter,
                minValue: min ? Number(min) : null,
                maxValue: max ? Number(max) : null,
            });

            const isEmptyRange = !min && !max;

            sendFiltersGtag(filterTitleForGtag, isEmptyRange ? EventAction.RemoveFilter : EventAction.AddFilter);

            const {pathName} = filterInstance.userAddFilterRangeValues(data);
            pushRoute(pathName, undefined, {scroll: false, shallow: true});
        },
        [filter, filterInstance, filterList, pushRoute, sendFiltersGtag],
    );

    const {enum: options, maxRange, minRange, maxValue, minValue, unit} = filter;

    const withCount = isFilterWithCount(filter);

    return (
        <FilterRangeInputs
            defaultMaxValue={maxValue}
            defaultMinValue={minValue}
            maxRange={maxRange}
            minRange={minRange}
            onApply={handleApply}
            options={options}
            unit={unit}
            withCount={withCount}
        />
    );
};
